import { NetworkStatus } from '@apollo/client';

/** Catch-up reads must be new requests, and each subscription needs its own ack. */
export const unitPowerReadContext = { queryDeduplication: false };

/** Wait for initial/new-variable snapshots without unsubscribing during refetch. */
export function unitPowerEventIds(
  ids: string[],
  status: NetworkStatus,
): string[] {
  return status === NetworkStatus.loading ||
    status === NetworkStatus.setVariables
    ? []
    : ids;
}
